import React from 'react';
import { SectionTitle, InsightBox, ScoreBar, TrendBadge, MR, JB } from './DemoShared';

export function RealityCheck({ club, dt }) {
  const r = dt.reality;
  return (
    <section data-testid="section-reality">
      <SectionTitle
        label={r.eyebrow}
        title={r.title(club.name)}
        subtitle={r.subtitle}
        as="h1"
      />
      <div className="grid md:grid-cols-3 gap-5 mb-6">
        <div className="rounded-xl border border-border/40 bg-card/50 p-6" data-testid="brand-score-card">
          <p className="text-xs text-muted-foreground/60 uppercase tracking-wider mb-3" style={JB}>{r.brandScore}</p>
          <div className="flex items-baseline gap-2 mb-3">
            <span className="text-4xl font-bold text-foreground" style={MR}>{club.brandScore}</span>
            <span className="text-sm text-muted-foreground">/100</span>
          </div>
          <ScoreBar value={club.brandScore} />
          <p className="text-[11px] text-[hsl(38,85%,55%)] mt-3 leading-relaxed">{club.scoreContext}</p>
        </div>

        <div className="rounded-xl border border-border/40 bg-card/50 p-6" data-testid="brand-value-card">
          <p className="text-xs text-muted-foreground/60 uppercase tracking-wider mb-3" style={JB}>{r.brandValue}</p>
          <div className="flex items-baseline gap-1 mb-1">
            <span className="text-lg text-muted-foreground">&euro;</span>
            <span className="text-4xl font-bold text-foreground" style={MR}>{club.brandValue}</span>
            <span className="text-lg text-muted-foreground">M</span>
          </div>
          <p className="text-[11px] text-muted-foreground" style={JB}>{r.range}: &euro;{club.brandValueLow}&ndash;{club.brandValueHigh}M</p>
        </div>

        <div className="rounded-xl border border-border/40 bg-card/50 p-6" data-testid="brand-trend-card">
          <p className="text-xs text-muted-foreground/60 uppercase tracking-wider mb-3" style={JB}>{r.yoyTrend}</p>
          <div className="flex items-baseline gap-3 mb-1">
            <TrendBadge value={club.trend} />
          </div>
          <p className="text-sm text-muted-foreground mt-2">{club.trendLabel}</p>
        </div>
      </div>

      <div className="rounded-xl border border-[hsl(38,85%,55%)]/15 bg-[hsl(38,85%,55%)]/[0.03] p-5 mb-6" data-testid="peer-gap-card">
        <p className="text-xs text-[hsl(38,85%,55%)]/60 uppercase tracking-wider mb-2" style={JB}>{r.peerContext}</p>
        <p className="text-sm text-foreground/90 font-medium leading-relaxed">{club.peerGap}</p>
      </div>

      <InsightBox variant={club.trend < 0 ? 'warning' : 'default'}>
        {club.realityInsight}
      </InsightBox>
    </section>
  );
}
